import {
  useStyle 
} from "@/classify"
import {
  useToasts 
} from "@/hooks/Toasts/useToasts"
import Toast from "./toast"
import defaultClasses from "./toastContainer.module.css"

const ToastContainer = (props) => {
  const classes = useStyle(defaultClasses, props.classes)
  const [{
    toasts 
  }] = useToasts()

  // Given a map of toasts each with a property "timestamp", sort and display
  // based on the timestamp.
  const sortByTimestamp = ([, toastA], [, toastB]) => toastA.timestamp - toastB.timestamp

  const toastElements = Array.from(toasts)
    .sort(sortByTimestamp)
    .map(([id, toast]) => {
      const key = toast.isDuplicate ? Math.random() : id

      return <Toast key={key} {...toast} />
    })

  return (
    <div id='toast-root' className={classes.root}>
      {toastElements}
    </div>
  )
}

export default ToastContainer
